<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  catalog: { type: Object, default: () => ({}) },
  responsavelComprador: { type: String, default: '' },
});

const emit = defineEmits(['update:responsavelComprador']);

const { t } = useI18n();
const buyerOptions = computed(() =>
  (props.catalog.buyers || []).map(party => ({
    value: party.id.toString(),
    label: party.name,
  }))
);
</script>

<template>
  <section class="grid gap-4">
    <h2 class="text-lg font-semibold text-lais-text">
      {{ t('POST_SALE.FORM.ITBI.TITLE') }}
    </h2>
    <label class="grid gap-1 text-sm font-semibold text-lais-text-body">
      {{ t('POST_SALE.FORM.BUYER_RESPONSIBLE') }}
      <select
        :value="responsavelComprador"
        class="min-h-10 rounded-lais border border-lais-border bg-white px-2 font-normal"
        @change="emit('update:responsavelComprador', $event.target.value)"
      >
        <option value="">{{ t('POST_SALE.FORM.SELECT') }}</option>
        <option
          v-for="option in buyerOptions"
          :key="option.value"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
    </label>
  </section>
</template>
